import { buildApiURL, apiGet, apiPost, apiPut, apiDelete } from '@src/services/api';

/**
 * Agency Locations API Service
 * Handles all API calls related to agency locations management
 */

/**
 * Fetch agency locations for a specific premier access group
 * @param {string} premierAccessGroupId - The premier access group ID
 * @param {Object} params - Additional query parameters (search, page, etc.)
 * @returns {Promise} - API response with agency locations data
 */
export const fetchAgencyLocations = (premierAccessGroupId, params = {}) => {
    const queryParams = {
         
        premier_access_group_id: premierAccessGroupId,
        ...params,
    };

    const url = buildApiURL('/api/v1/agency_locations', queryParams);
    return apiGet(url);
};

/**
 * Create a new agency location
 * @param {Object} locationData - The agency location data to create
 * @returns {Promise} - API response with created location
 */
export const createAgencyLocation = (locationData) => {
    const url = buildApiURL('/api/v1/agency_locations');
     
    return apiPost(url, { agency_location: locationData });
};

/**
 * Update an existing agency location
 * @param {string} locationId - The agency location ID
 * @param {Object} locationData - The updated agency location data
 * @returns {Promise} - API response with updated location
 */
export const updateAgencyLocation = (locationId, locationData) => {
    const url = buildApiURL(`/api/v1/agency_locations/${locationId}`);
     
    return apiPut(url, { agency_location: locationData });
};

/**
 * Delete an agency location
 * @param {string} locationId - The agency location ID to delete
 * @returns {Promise} - API response
 */
export const deleteAgencyLocation = (locationId) => {
    const url = buildApiURL(`/api/v1/agency_locations/${locationId}`);
    return apiDelete(url);
};

/**
 * Fetch a single agency location by ID
 * @param {string} locationId - The agency location ID
 * @returns {Promise} - API response with agency location data
 */
export const fetchAgencyLocation = (locationId) => {
    const url = buildApiURL(`/api/v1/agency_locations/${locationId}`);
    return apiGet(url);
};
